module.exports = { "default": require("core-js/library/fn/symbol/replace"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/symbol/replace.js
// module id = fTjv
// module chunks = 3